(ns dashboard.services.error-reporting
  "Report uncaught exceptions to the backend, rate limited with via a token bucket (allows to report small burts of errors, and limits error reporting rate).
  In order to use, add a HTTP POST route to the backend that accepts a JSON message at \"/frontend-logs\" path"
  (:require [re-frame.core :as rf]
            [ajax.core :as ajax]
            [io.repliance.util.token-bucket :as t])
  (:require-macros [io.repliance.util.version :refer [get-version-info]]))

(def default-burst
  "Burst of error reports allowed"
  5)

(def default-rate
  "Continuous rate of error reports allowed"
  1)

(rf/reg-event-fx
  ::report-error
  (fn [_ [_  error]]
    {:fx [[:http-xhrio {:method          :post
                        :uri             "/api/frontend-logs"
                        :params          error
                        :format          (ajax/json-request-format)
                        :response-format (ajax/json-response-format)
                        :on-success      [::report-success]
                        :on-failure      [::report-failure]}]]}))

(rf/reg-event-fx
  ::report-success
  (fn []
    {}))

(rf/reg-event-fx
  ::report-failure
  (fn []
    ;; Failed to report so just log
    (js/console.error "Failed to send error report")
    {}))

(defonce error-reporting-token-bucket-atom (atom nil))

(defn enable-error-reporting!
  ([]
   (enable-error-reporting! default-burst default-rate))
  ([burst rate]
   (when-not @error-reporting-token-bucket-atom
     (reset! error-reporting-token-bucket-atom (t/make-token-bucket burst rate))
     (.addEventListener js/window "error" (fn [^js e]
                                            (when (and (.-error e)
                                                       (not (.. e -error -reported))
                                                       (t/consume error-reporting-token-bucket-atom))
                                              (rf/dispatch [::report-error
                                                            {:error-info  {:message (.-message e)
                                                                           :filename (.-filename e)
                                                                           :lineno (.-lineno e)
                                                                           :colno (.-colno e)
                                                                           :error-name (.. e -error -name)
                                                                           :stack (.. e -error -stack)}
                                                             :user-agent (.-userAgent js/navigator)
                                                             :version-info (get-version-info)
                                                             :location-href (.-href js/location)}])
                                              ;; To prevent reporting twice, caused by React devtools probably
                                              (set! (.. e -error -reported) true)))))))

